import React, { useState } from "react";
// import dum from "../../../assets/Thiru-dummy/dummy-image-24toolbox-550x480.png";
import CoreComponent from "../../../assets/Sub-component/CoreComponent";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import CoreComponent3 from "../../../assets/Sub-component/CoreComponent3";
import CoreComponent12 from "../../../assets/Sub-component/CoreComponent12";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import { Helmet } from "react-helmet";

import HeaderThree from "../../../components/header/HeaderThree";

import years from "../../../assets/Mobile-app/Your-Way-to-Tech-Success/Years-of-Excellence.svg";
import tech from "../../../assets/Mobile-app/Your-Way-to-Tech-Success/Technology-Expert.svg";
import projects from "../../../assets/Mobile-app/Your-Way-to-Tech-Success/Projects-Delivered.svg";

import money from "../../../assets/Mobile-app/Our-Way-of-Ensuring-Complete/Money-Back.svg";
import digital from "../../../assets/Mobile-app/Our-Way-of-Ensuring-Complete/Digital-Promotion.svg";
import maintenance from "../../../assets/Mobile-app/Our-Way-of-Ensuring-Complete/Maintenance-and-Support.svg";
import product from "../../../assets/Mobile-app/Our-Way-of-Ensuring-Complete/NDA-Producted.svg";

import mobileapp from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Mobile-App-Development.svg";
import game from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Game-app-development.svg";
import iphone from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Iphone-app-development.svg";
import android from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Android-app-development.svg";
import cross from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Cross-platform-mobile-app.svg";
import wearable from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Wearable-app-development.svg";
import enterprise from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Enterprise-solution.svg";
import webapp from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Web-app-development.svg";

import infograph from "../../../assets/Mobile-app/Infograph.svg";
import InnovativeSuccess from "../../../assets/Sub-component/InnovativeSuccess";
import { Link } from "react-router-dom";

import dum from "../../../assets/Services/mobile_app_img/ui-ux-representations-with-smartphone.jpg";
import Faq from "../pages/Faq";
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import launchingimage from '../../../assets/Launchingimage.png'
import Contact from "../features/miscellaneous/contact";


const MobileAppDevelopment = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const partners = [
    {
      icon: maintenance,
      title: "1+ year Free Maintenance and Support",
    },
    {
      icon: digital,
      title: "Digital Promotion Boosters",
    },
    {
      icon: product,
      title: "NDA Protected Apps",
    },
    {
      icon: money,
      title: "100% Money-Back Guarantee",
    },
  ];

  const service = [
    {
      icon: mobileapp,
      title: "Mobile App Development",
      desc: "We provide complete Mobile App Development for tablets and smartphones, ensuring a strong mobile presence for your business.",
      icon2: webapp,
      title2: "Web app development",
      desc2:
        "Creating mobile-friendly applications that are accessible on any device. Our services include full conception, deployment, and maintenance for scalable web solutions.",
    },
    {
      icon: game,
      title: "Game app development",
      desc: "Bringing immersive mobile games to life from idea to post-launch updates. We handle everything, helping businesses .",
      icon2: android,
      title2: "Android App Development",
      desc2:
        "Possessing powerful and versatile native apps for the Android ecosystem. Our apps are compatible with the world's largest mobile user base and are scalable and high-performing.",
    },
    {
      icon: iphone,
      title: "iphone app development",
      desc: "We create high-quality native iOS apps for optimal performance and premium user experience, fully leveraging Apple devices .",
      icon2: wearable,
      title2: "Wearable app development",
      desc2:
        "Developing cutting-edge applications for smartwatches and other seamlessly connected gadgets. We design efficient apps that extend digital functionality.",
    },
    {
      icon: enterprise,
      title: "Enterprise solution",
      desc: "We provide personalized software solutions that streamline operations and data, creating secure systems to boost efficiency.",

      icon2: cross,
      title2: "Cross-platform mobile app",
      desc2:
        "Our mobile app developers create apps with a single codebase that run smoothly on iOS and Android devices. We deliver , cost-effective apps for consistent user experience .",
    },
  ];
const handleClick=(e)=>{
    
    e.preventDefault()
    console.log(form)
   axios.post('http://localhost:5000/contact',form) 
   
   .then((response)=>{setForm(response.data)
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }
  return (
    <>
    <img src={launchingimage} className="Bg-image"></img>   
    <div className="main-page-wrapper  overflow-mobileapp">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      {/* hero banner */}

      <div className="container ">
        <div className=" d-flex align-items-center justify-content-center flex-column topheader-margin height-vh">
          <h1 className="fw-bold text-center h1-heading">
            Mobile App Development
          </h1>
          <p className="h1-para  text-center mt-lg-4 mt-3 mb-4 ">
            We build impactful digital solutions, craft engaging user
            experiences, and empower businesses to innovate and lead in the
            evolving digital world.
          </p>
          <Link to="/request-quote">
            <button className=" mt-3 py-3 px-4 h1-para  btn-gradient fw-less border-0 text-white rounded-4">
              Get Your Free Quote
            </button>
          </Link>
        </div>

        <div className="row  pb-80 d-flex align-items-center">
          <h2 className="fw-semibold text-center h2-heading">
            Mobilizing Enterprise Transformation
          </h2>
          <p className="text-center mt-lg-4 mt-2 mb-4 h1-para">
            Your startup's success elevator
          </p>
          <div className="col-lg-6">
            <p className="me-lg-5 mb-3 lh-base h1-para   ">
              Raiden is a specialized Mobile App Development company
              that provides businesses with the benefit of emerging technology
              and helps them stay competitive in a rapidly changing digital
              market. We develop your ideas to create innovative and interactive
              experiences that improve user engagement and set the brands apart
              by concentrating on blockchain development, augmented reality
              (AR), virtual reality (VR), and the metaverse.
            </p>
            <p className="me-lg-5 mb-3 lh-base h1-para    " >
              Utilizing advanced methods like NFTs and decentralized finance, we
              enable your business to access new revenue sources while
              guaranteeing their apps are future-proof with improved security
              and transparency.
            </p>
          </div>
        <Contact/>
        </div>

        {/* < !---------Our Achievement------------>  */}

        <div className="mt-80 row">
          <div className="col-lg-6">
            <h2 className="h2-heading fw-semibold mb-3 ">
              Driving Digital Mobile Transformation Together
            </h2>
            <p className="me-lg-5 mb-4 h1-para">
              We're bringing advanced technology, great user experiences, and
              innovative strategies together by designing and building mobile
              applications and pairing product innovation with product strategy.
              Collaborate with our mobile app developers—not
              only do they continually remain to date with the latest industry
              innovations, but they’re also influencing and inspiring the
              digital age. We are a Mobile App Development
              company in Toronto that makes your brand shine, whether you are a
              startup or an enterprise.
            </p>
          </div>
          <div className="col-md-6 d-flex justify-content-center  align-items-end  ">
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ width: 300, height: 250, background: "#f9fbf9" }}
            >
              <h2 className="fw-semibold font-gordita h2-heading">10</h2>
              <p className="font-raleway h3-para">Years Experience</p>
            </div>
            <div
              className="d-flex flex-column justify-content-center align-items-center shadow"
              style={{ width: 300, height: 250 }}
            >
              <h2 className="font-gordita h2-heading">500+</h2>
              <p className="font-raleway h3-para">Projects Delivered</p>
            </div>
          </div>

          <div className=" d-flex justify-content-end">
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ width: 285, height: 250, background: "#f9fbf9" }}
            >
              <h2 className="font-gordita h2-heading">20+</h2>
              <p className="font-raleway h3-para">Countries Served</p>
            </div>
            <div
              className="d-flex flex-column justify-content-center align-items-center shadow"
              style={{ width: 285, height: 250 }}
            >
              <h2 className="font-gordita h2-heading">95%</h2>
              <p className="font-raleway h3-para">Retention Rate </p>
            </div>
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ width: 285, height: 250, background: "#f9fbf9" }}
            >
              <h2 className="font-gordita h2-heading">25+</h2>
              <p className="font-raleway h3-para">Awards</p>
            </div>
          </div>
        </div>

        {/* <!-------- TechGropse -------->  */}
        <div className="row mt-80 mb-80 ">
          <div className="col-lg-6">
            <h2 className="fw-semibold mb-3 h2-heading ">
              Experience Raiden's Difference in Mobile Development
            </h2>
            <p className="mb-3 h1-para" >
              Raiden develops mobile applications that transform user's digital
              experiences. We are committed to creating innovative and practical
              applications that truly add value and create new possibilities for
              users. We incorporate safe features that increase users'
              confidence and control.
            </p>
            <p className="mb-3 h1-para" >
              We focus on advanced digital solutions, allowing us to develop
              apps that fit perfectly into today's changing digital spaces.
              Whether you imagine a visually striking app or one that engages
              users,our top mobile app developers make it happen.
            </p>
            <p className="mb-4 h1-para" >
              Raiden is your dedicated partner, ready to turn your creative
              mobile app concept into an extraordinary reality, particularly if
              your idea seeks to break new ground.
            </p>
            <div className="row">
              <div className="col-lg-4  ">
                <img src={years} alt="" style={{ height: 50, width: 50 }} />
                <p className="text-center mt-2 h1-para">
                  10+ Years of <br />
                  Excellence
                </p>
              </div>
              <div className="col-lg-4  mt-3 mt-lg-0 ">
                <img src={projects} alt="" style={{ height: 50, width: 50 }} />
                <p className="text-center mt-2 h1-para">
                  1000+ Projects <br /> Delivered
                </p>
              </div>
              <div className="col-lg-4 mt-3 mt-lg-0">
                <img src={tech} alt="" style={{ height: 50, width: 50 }} />
                <p className="text-center mt-2 h1-para">
                  200+ Technology <br />
                  Experts
                </p>
              </div>
            </div>
            <Link to="/request-quote" className="d-lg-block d-flex">
              <button className="h1-para px-3 py-2 mb-3 mb-lg-0  rounded-2 btn-gradient mt-30 ms-lg-4 mx-auto  text-white">
                Know More
              </button>
            </Link>
          </div>
          <div className="col-lg-6 d-md-block d-none">
            <img src={dum} alt="mobile app " />
          </div>
        </div>

        {/* <!------Our Way of Ensuring Complete ---------!>  */}
        <div className="text-center mb-80 marb ">
          <h2 className="fw-semi-bold mb-3 h2-heading ">
            Our Way of Ensuring Complete Satisfaction for Our Partners
          </h2>
          <p className="fw-less h1-para mb-2">We empower your digital brand</p>
          <div className="row mt-30 d-flex justify-content-between ">
            {partners.map((val, i) => (
              <div
                className="col-md-6  col-lg-3 mx-auto d-flex justify-content-center"
                key={i}
              >
                <div
                  className=" px-3 py-4   hover-shadow"
                  style={{ height: 200, width: 250 }}
                >
                  <img src={val.icon} alt="" />
                  <p className="mt-4  h1-para">{val.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <!-----Cognitive Integrated  ------> */}
      <div className="pt-60 pb-60 padb padt bg-black overflow-hidden">
        <h2 className="text-center text-white mb-35 h2-heading ">
          Integrating Innovative Methods for Your Success
        </h2>
        <InnovativeSuccess service={service} />
      </div>

      {/* <!-----Development Strategy-----!> */}

      <div className=" container mt-80 text-center">
        <h2 className="mb-4 pb-lg-2 h2-heading ">
          Our Agile Development Strategy
        </h2>
        <img src={infograph} alt="" className="mb-4 mt-3 w-100" />
        <Link to="/request-quote" className="d-lg-block d-flex">
          <button className="btn-gradient text-white px-4 py-2 h1-para rounded-2 m-auto ">
            Know More
          </button>
        </Link>
      </div>

      {/* <!-------Future Success-----!> */}
      <div className="">
        <CoreComponent3 />
      </div>

      {/* <!--- Technology---->  */}
      <div className="container mt-80  marb ">
        <div className=" row">
          <h2 className="text-center mb-50 h2-heading ">
            {" "}
            Empowering Your Growth with Technology
          </h2>
          <CoreComponent />
        </div>
      </div>

      {/* <!------Industries We Work-----!> */}
      <div>
        <CoreComponent2 />
      </div>

      {/* <!----Genai solutions ----!> */}
      <div className="container  pt-60 pb-60 px-5   rounded-5 mb-80 marb padt padb  text-center"style={{ backgroundColor: "#f5f9f9ff" }} >
        <h2 className="fw-semibold fs-2 text-black lh-base h2-heading ">
          Mobile App idea? 
        </h2>
        <p className="fw fs-2 text-black lh-base h2-heading ">Raiden makes your vision a digital success.</p>
        <Link to="/request-quote" className="d-lg-block d-flex">
          <button className="btn-gradient text-white  text-center m-auto mt-4 px-4 py-2 rounded-5 fw-less">
            Call With Us
          </button>
        </Link>
      </div>
      {/* <FaqHome/> */}

      {/* <!-----All Expertises!---> */}
      {/* <div className="text-center">
        <h2 className=" mb-4 h2-heading ">The Master Jack of All Expertises </h2>
        <div>
          <CoreComponent12 />
        </div>
      </div> */}

      <footer className="theme-footer-two pt-150 lg-pt-80">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default MobileAppDevelopment;
